import { useEffect, useState } from 'react'
import { useCallTrackingContext } from '../context'
import { fetchCallTrackingDetailsEffect } from '../effects'
import { RequestStatus } from '@sales-center/common'
import type { ENTITY_TYPES } from '@sales-center/common'

export function useFetchCallTrackingDetails(type: ENTITY_TYPES, id: number) {
  const [, dispatch] = useCallTrackingContext()
  const [status, setStatus] = useState<RequestStatus>('idle')

  useEffect(() => {
    let mounted = true

    const execute = () => {
      setStatus('loading')
      const action = fetchCallTrackingDetailsEffect(type, id)

      if (mounted) {
        dispatch(action)
        setStatus('idle')
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, id, type])

  return status
}
